import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import { requestUndoSupersedSite } from 'api/site'
import { SiteSupersedeModalFooter, SiteSupersedeModalFooterButtonWrapper, SiteSupersedeModalText } from './style'


const SiteRevertStatusModal = ({ site, toggleModal, getSite }) => {
  const closeModal = () => {
    toggleModal({})
  }

  const revertSupersededStatus = () => {
    requestUndoSupersedSite(site.id).then((data) => {
      toggleModal({})
      getSite()
    })
  }

  return (
    <>
      <SiteSupersedeModalText>
        <FormattedMessage id="changeStatusToConfirmFromSupersede" values={{ name: <b>{site.name}</b> }} />
      </SiteSupersedeModalText>
      <SiteSupersedeModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <SiteSupersedeModalFooterButtonWrapper>
          <Button type="primary" onClick={revertSupersededStatus}>
            <FormattedMessage id="changeStatus" />
          </Button>
        </SiteSupersedeModalFooterButtonWrapper>
      </SiteSupersedeModalFooter>
    </>
  )
}

SiteRevertStatusModal.propTypes = {
  site: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  getSite: PropTypes.func.isRequired,
}

export default SiteRevertStatusModal
